import { action } from 'satcheljs';
export var onMailSearchComplete = action('ON_MAIL_SEARCH_COMPLETE');
//# sourceMappingURL=mailSearchActions.js.map